import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import SubmitButton from '../common/buttons/SubmitButton'
import styles from './EventInProgressCard.module.scss'

const EventInProgressCard = ({ onClick }) => {
  const { t } = useTranslation()

  return (
    <div className={styles.messageCard}>
      <i className='fa fa-exclamation-triangle' />
      <span className='ml-3'>{t('events.list.eventInProgressCard.quickLogInProgress')}</span>
      <div className={styles.continueEditingButton}>
        <SubmitButton
          className='mb-3'
          buttonMessage={t('common.flow.continueEditing')}
          buttonColor='orange-button'
          onClick={onClick}
        />
      </div>
    </div>
  )
}

EventInProgressCard.propTypes = {
  onClick: PropTypes.func.isRequired,
}

export default EventInProgressCard
